import { formatTimeMarker, getTimeInterval } from '@routes/Workflow/util'

interface MarkersProps {
  startTime: number
  endTime: number
  duration: number
}

function Markers({ startTime, endTime, duration }: MarkersProps) {
  const { interval, label } = getTimeInterval(duration)

  const markers: number[] = []
  let currentMarker = Math.ceil(startTime / interval) * interval
  while (currentMarker <= endTime) {
    markers.push(currentMarker)
    currentMarker += interval
  }

  return (
    <div className="relative mb-2 h-8">
      {markers.map((markerTime) => {
        const position = ((markerTime - startTime) / duration) * 100
        return (
          <div
            key={markerTime}
            className="absolute top-0"
            style={{ left: `${position}%` }}
          >
            <div className="relative">
              <div className="absolute -left-8 w-16 text-center text-xs text-secondary">
                {formatTimeMarker(new Date(markerTime), label)}
              </div>
              <div className="h-4 w-px bg-gray-300" />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Markers